import { throttle } from '@tencent/exeditor3-core';
export const fixFloatNumber = (originNumber, fractionDigits = 4) => {
    let floatNumber = originNumber || 0;
    floatNumber = +floatNumber.toFixed(fractionDigits);
    return floatNumber;
};
export const px = (n, fractionDigits = 4) => `${fixFloatNumber(n || 0, fractionDigits)}px`;
export const pp = (n, fractionDigits = 6) => {
    const percent = fixFloatNumber(n * 100, fractionDigits);
    return `${percent}%`;
};
export const wrapMouseMove = ({ onMove, onLeave, }) => {
    const handleMouseMove = throttle(onMove, 15);
    const handleMouseRelease = (event) => {
        handleMouseMove.flush();
        window.removeEventListener('mouseup', handleMouseRelease);
        window.removeEventListener('blur', handleMouseRelease);
        window.removeEventListener('mousemove', handleMouseMove);
        onLeave(event);
    };
    window.addEventListener('mouseup', handleMouseRelease);
    window.addEventListener('blur', handleMouseRelease);
    window.addEventListener('mousemove', handleMouseMove);
};
// 顺序 (从12点方向开始)
const octopath = ['ns', 'nesw', 'ew', 'nwse', 'ns', 'nesw', 'ew', 'nwse'];
export const getCursorOrder = (rotate, postfix = 'resize') => {
    const period = Math.floor(rotate / (2 * Math.PI));
    const phase = rotate - period * (2 * Math.PI);
    const count = Math.round(phase / (Math.PI / 4)) % 8;
    const order = octopath
        .slice(count)
        .concat(octopath.slice(0, count))
        .map((direction) => `${direction}-${postfix}`);
    return order;
};
export const styled = (obj) => {
    const result = [];
    Object.keys(obj).forEach((key) => {
        const value = obj[key];
        if (value) {
            result.push(`${key}:${value};`);
        }
    });
    return result.join('');
};
export const decomposeVector = (x, y, rotate) => {
    const sin = Math.sin(rotate);
    const cos = Math.cos(rotate);
    const dx = x * cos + y * sin;
    const dy = -x * sin + y * cos;
    return { x: dx, y: dy };
};
export const calculateDisplayRect = (info) => {
    const { width, height, rotate } = info;
    const { width: cropWidth, height: cropHeight, x: cropX, y: cropY, } = info.crop || {};
    const dx = cropX || 0;
    const dy = cropY || 0;
    const w = cropWidth || width || 0;
    const h = cropHeight || height || 0;
    const a = rotate || 0;
    const sin = Math.sin(a);
    const cos = Math.cos(a);
    const vw = w * Math.abs(cos) + h * Math.abs(sin);
    const vh = w * Math.abs(sin) + h * Math.abs(cos);
    const dw = (sin < 0 ? 0 : h * sin) + (cos > 0 ? 0 : w * -cos);
    const dh = (sin > 0 ? 0 : w * -sin) + (cos > 0 ? 0 : h * -cos);
    return {
        width: vw,
        height: vh,
        realWidth: w,
        realHeight: h,
        offsetX: dw,
        offsetY: dh,
        x: dx,
        y: dy,
        rotate: Math.cos(a) === 1 ? 0 : a,
    };
};
//# sourceMappingURL=utils.js.map